import {HttpError} from "./http.error";

export default class ServerError extends HttpError {
    /**
     * Constructor
     * @param statusCode {int}
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(statusCode, message, response, previous) {
        super(statusCode, message, response, previous);
        this.name = 'ServerError';
    }
}